'use client'

import { useDirectoryContext } from '@/features/drive/entities/directory/directory-context'
import { createContext, useContext, useMemo, useState } from 'react'
import { DirectoryCreateOrUpdateModal } from '@/features/drive/functionalities/actions/node/core/shared/directory-create-or-update-modal/directory-create-or-update-modal'

interface IDirectoryCreateDirectoryContext {
    isModalOpen: boolean
    setIsModalOpen: undefined | ((isOpen: boolean) => void)
}

const DirectoryCreateDirectoryContext = createContext<IDirectoryCreateDirectoryContext>({
    isModalOpen: false,
    setIsModalOpen: undefined,
})

export const DirectoryCreateDirectoryContextProvider = ({ children }: { children: React.ReactNode }) => {
    const { nodeSource } = useDirectoryContext()

    const [isCreateDirectoryModalOpen, setIsCreateDirectoryModalOpen] = useState(false)

    return (
        <DirectoryCreateDirectoryContext.Provider
            value={useMemo(
                () => ({
                    isModalOpen: isCreateDirectoryModalOpen,
                    setIsModalOpen: nodeSource === 'drive' ? setIsCreateDirectoryModalOpen : undefined,
                }),
                [isCreateDirectoryModalOpen, setIsCreateDirectoryModalOpen, nodeSource]
            )}
        >
            <DirectoryCreateOrUpdateModal
                directory={undefined}
                open={isCreateDirectoryModalOpen}
                onOpenChange={setIsCreateDirectoryModalOpen}
            />

            {children}
        </DirectoryCreateDirectoryContext.Provider>
    )
}

export const useDirectoryCreateDirectoryContext = () => useContext(DirectoryCreateDirectoryContext)
